export default [
  {value: 'tons-feet', label: 'Tons & Feet', system: 'english', forceUnit: 'tons'},
  {value: 'kips-feet', label: 'Kips & Feet', system: 'english', forceUnit: 'kips'},
  {value: 'kn-meter', label: 'kNs & Meters', system: 'metric', forceUnit: 'kn'},
  {value: 'mton-meter', label: 'Metric Tons & Meters', system: 'metric', forceUnit: 'mtons'}
]
